import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import dateFormat from 'dateformat';

import { formatDateWithHour } from 'src/utils/Date';
import { Label } from 'jbc-front/components/Form';
import { takePaymentDateFromSearchForm } from 'src/reducers/searchForm';
import ChangePayReleaseDateForm from 'src/features/EmployeePays/components/ChangePayReleaseDateForm';
import styles from './PayTargetDateRange.scss';
import { withTranslation } from 'react-i18next';

class PayTargetDateRange extends React.Component {
  state = {
    changeReleaseDateModalOpen: false
  };

  hideModal = () => this.setState({ ...this.state, changeReleaseDateModalOpen: false });
  showModal = () => this.setState({ ...this.state, changeReleaseDateModalOpen: true });

  render() {
    const { paymentRange, releaseDateVisibility = false } = this.props;

    const targetStartDate = _.has(paymentRange, 'targetStartDate')
      ? dateFormat(paymentRange.targetStartDate, 'dd/mm/yyyy')
      : '';
    const targetEndDate = _.has(paymentRange, 'targetEndDate')
      ? dateFormat(paymentRange.targetEndDate, 'dd/mm/yyyy')
      : '';
    const paymentDate = _.has(paymentRange, 'value') ? paymentRange.value.replace(/_/g, '/') : '';
    const releaseDate = _.has(paymentRange, 'releaseDate') ? formatDateWithHour(paymentRange.releaseDate) : '';
    const sendNotifyToEmployee = !!_.get(paymentRange, 'sendNotifyToEmployee');
    const locale = _.get(paymentRange, 'locale');

    const attendanceTargetStartDate = _.has(paymentRange, 'attendanceTargetStartDate')
      ? dateFormat(paymentRange.attendanceTargetStartDate, 'dd/mm/yyyy')
      : '';
    const attendanceTargetEndDate = _.has(paymentRange, 'attendanceTargetEndDate')
      ? dateFormat(paymentRange.attendanceTargetEndDate, 'dd/mm/yyyy')
      : '';

    const diffRange = targetStartDate !== attendanceTargetStartDate;

    return (
      <div className={styles.container}>
        <div>
          {this.props.t('features.EmployeeAttendances.EmployeeAttendanceDownloadCsvPage.subjected_period')} {targetStartDate} 〜 {targetEndDate}
        </div>
        {diffRange && (
          <React.Fragment>
            <div>
              （{this.props.t('components.PayTargetDateRange.Applicable_attendance_period')} {attendanceTargetStartDate} ~ {attendanceTargetEndDate}）
            </div>
            <div className={styles.hintIcon}>
              <Label
                note={
                  <p>
                    {this.props.t('components.PayTargetDateRange.Overtime_and_attendance_deductions_for_monthly_wage_employees_and_salary_for_daily_and_hourly_wage_employees_will_be_calculated_from_the_previous_months_attendance')}<br />{this.props.t('components.PayTargetDateRange.If_the_applicable_period_and_the_applicable_attendance_period_are_the_same_the_applicable_attendance_period_will_not_be_displayed')}
                  </p>
                }
              />
            </div>
          </React.Fragment>
        )}
        <div className={styles.paymentDate}>
          {this.props.t('features.EmployeeAttendances.EmployeeAttendanceDownloadCsvPage.payment_date')} {dateFormat(paymentDate, 'dd/mm/yyyy')}
        </div>
        {releaseDateVisibility && (
          <React.Fragment>
            <div className={`${styles.releaseDate} ${styles.canClick}`} onClick={this.showModal} role="presentation">
              {this.props.t('components.PayTargetDateRange.Disclosure_date')}&nbsp;{releaseDate}
            </div>
            <ChangePayReleaseDateForm
              releaseDate={paymentRange.releaseDate}
              sendNotifyToEmployee={sendNotifyToEmployee}
              locale={locale}
              isOpen={this.state.changeReleaseDateModalOpen}
              hideModal={this.hideModal}
            />
          </React.Fragment>
        )}
      </div>
    );
  }
}

export default withTranslation('translation')(connect((state, ownProps) => ({
  paymentRange: takePaymentDateFromSearchForm(state, ownProps.formName)
}))(PayTargetDateRange));
